<p-toast></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>
<p-menu #menuContextuelNonConformite popup="popup" [model]="menuContextuelNonConformite"></p-menu>

<div class="grid">
    <div class="col-12">
        <p-card>

            <p-table #dt [value]="nonConformitesFiltrees" [columns]="colonnesSelectionnees" scrollable rowhover [loading]="!EstCharge()" autoLayout="true"
                [globalFilterFields]="['numero', 'titre', 'codeProjet', 'statut', 'dateEmission', 'dateDetection', 'objet', 'employe', 'approbation']"
                [(selection)]="selectedNonConformites" dataKey="id" [totalRecords]="nonConformitesFiltrees?.length"
                [sortField]="tableParams.getValue().sortField"
                [sortOrder]="tableParams.getValue().sortOrder"
                (onFilter)="tableParams.setValue(dt)" 
                (onSort)="tableParams.setValue(dt)" 
                (onPage)="tableParams.setValue(dt)">
                <ng-template pTemplate="caption">
                    <div class="flex flex-wrap gap-3 align-items-center justify-content-between">
                        <div class="flex flex-wrap align-items-center gap-3">
                            <span class="p-input-icon-left">
                                <i class="pi pi-search"></i>
                                <input pInputText type="text" [(ngModel)]="globalFilter" (input)="dt.filterGlobal($event.target.value, 'contains')"
                                    placeholder="Recherche..." />
                            </span>
                            <button pButton pRipple icon="pi pi-plus" label="Ajouter"
                                class="p-button-success"
                                (click)="newNonConformite()"></button>
                            <button pButton class="p-button-outlined"
                                icon="pi pi-filter-slash" (click)="clearFilters(dt)"></button>
                        </div>
                        <h5 class="titreTableau m-0">Non-conformités</h5>
                        <div class="flex align-items-center flex-wrap gap-3">
                            <p-checkbox (click)="filterNonConformites()" [(ngModel)]="showMine" inputId="showMine" binary trueValue="true" falseValue="false" [label]="'Afficher seulement mes non-conformités'" />
                            <button pButton pRipple icon="pi pi-file-pdf"
                                class="p-button-primary p-button-outlined" [pTooltip]="'Produire un rapport de compilation Excel'"
                                (click)="produireRapportCompilationNonConformite()"></button>
                            <p-multiSelect [options]="colonnesDisponibles" [(ngModel)]="selectedColumns"
                                optionLabel="entete" selectedItemsLabel="{0} colonnes sélectionnés"
                                (onChange)="surChangementColonnes($event)" [style]="{minWidth: '200px'}"
                                placeholder="Colonnes..."></p-multiSelect>
                        </div>
                    </div>
                </ng-template>
                <ng-template pTemplate="header">
                    <tr>
                        <th *ngIf="EstColonneSelectionnee('numero')" pSortableColumn="numero">
                            <div class="flex justify-content-between align-items-center">
                                Numéro
                                <p-sortIcon field="numero"></p-sortIcon>
                                <p-columnFilter type="text" field="numero" display="menu" class="ml-auto" />
                            </div>
                        </th>
                        <th *ngIf="EstColonneSelectionnee('titre')" pSortableColumn="titre">
                            <div class="flex justify-content-between align-items-center">
                                Titre
                                <p-sortIcon field="titre"></p-sortIcon>
                                <p-columnFilter type="text" field="titre" display="menu" class="ml-auto" />
                            </div>
                        </th>
                        <th *ngIf="EstColonneSelectionnee('codeProjet')" pSortableColumn="codeProjet.code">
                            <div class="flex justify-content-between align-items-center">
                                Projet
                                <p-sortIcon field="codeProjet.code"></p-sortIcon>
                                <p-columnFilter type="text" field="codeProjet.code" display="menu" class="ml-auto" />
                            </div>
                        </th>
                        <th *ngIf="EstColonneSelectionnee('statut')" pSortableColumn="statut">
                            <div class="flex justify-content-between align-items-center">
                                Statut
                                <p-sortIcon field="statut"></p-sortIcon>
                                <p-columnFilter field="statut" matchMode="in" display="menu" [showMatchModes]="false"
                                    [showOperator]="false" [showAddButton]="false">
                                    <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                                        <p-multiSelect [ngModel]="value" [options]="statuts" placeholder="Any"
                                            (onChange)="filter($event.value)" optionLabel="name">
                                            <ng-template let-option pTemplate="item">
                                                <div class="multiselect-representative-option">
                                                    <span class="ml-1">{{option.nom}}</span>
                                                </div>
                                            </ng-template>
                                        </p-multiSelect>
                                    </ng-template>
                                </p-columnFilter>
                            </div>
                        </th>
                        <th *ngIf="EstColonneSelectionnee('dateEmission')" pSortableColumn="dateEmission">
                            <div class="flex justify-content-between align-items-center">
                                Date de création
                                <p-sortIcon field="dateEmission"></p-sortIcon>
                                <p-columnFilter type="date" field="dateEmission" dateFormat="dd/mm/yyyy" display="menu" class="ml-auto" />
                            </div>
                        </th>
                        <th *ngIf="EstColonneSelectionnee('dateDetection')" pSortableColumn="dateDetection">
                            <div class="flex justify-content-between align-items-center">
                                Date de détection
                                <p-sortIcon field="dateDetection"></p-sortIcon>
                                <p-columnFilter type="date" field="dateDetection" dateFormat="dd/mm/yyyy" display="menu" class="ml-auto" />
                            </div>
                        </th>
                        <th *ngIf="EstColonneSelectionnee('type')">
                            <div class="flex justify-content-between align-items-center">
                                Catégorie
                                <p-sortIcon field="type"></p-sortIcon>
                                <p-columnFilter type="text" field="type" display="menu" class="ml-auto" />
                            </div>
                        </th>
                        <th *ngIf="EstColonneSelectionnee('objet')" pSortableColumn="objet">
                            <div class="flex justify-content-between align-items-center">
                                Type
                                <p-sortIcon field="objet"></p-sortIcon>
                                <p-columnFilter type="text" field="objet" display="menu" class="ml-auto" />
                            </div>
                        </th>
                        <th *ngIf="EstColonneSelectionnee('employe')" pSortableColumn="employe.nom">
                            <div class="flex justify-content-between align-items-center">
                                Employé
                                <p-sortIcon field="employe.nom"></p-sortIcon>
                                <p-columnFilter type="text" field="employe.nom" display="menu" class="ml-auto" />
                            </div>
                        </th>
                        <th *ngIf="EstColonneSelectionnee('approbation')" pSortableColumn="approbation">
                            <div class="flex justify-content-between align-items-center">
                                Approbation
                                <p-sortIcon field="approbation"></p-sortIcon>
                                <p-columnFilter type="text" field="approbation" display="menu" class="ml-auto" />
                            </div>
                        </th>
                        <th *ngIf="EstColonneSelectionnee('monetaire')" pSortableColumn="monetaire">
                            <div class="flex justify-content-between align-items-center">
                                Monétaire
                                <p-sortIcon field="monetaire"></p-sortIcon>
                                <p-columnFilter type="text" field="monetaire" display="menu" class="ml-auto" />
                            </div>
                        </th>
                        <th *ngIf="EstColonneSelectionnee('nbMessages')" pSortableColumn="nbMessages">
                            <div class="flex justify-content-between align-items-center">
                                Messages
                                <p-sortIcon field="nbMessages"></p-sortIcon>
                                <p-columnFilter type="text" field="nbMessages" display="menu" class="ml-auto" />
                            </div>
                        </th>
                        <th *ngIf="EstColonneSelectionnee('dateDernierMessage')" pSortableColumn="dateDernierMessage">
                            <div class="flex justify-content-between align-items-center">
                                Dernier message
                                <p-sortIcon field="dateDernierMessage"></p-sortIcon>
                                <p-columnFilter type="date" field="dateDernierMessage" dateFormat="dd/mm/yyyy" display="menu" class="ml-auto" />
                            </div>
                        </th>
                        <th alignFrozen="right" pFrozenColumn>Actions</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-nonConformite>
                    <tr>
                        <td *ngIf="EstColonneSelectionnee('numero')">
                            <a [routerLink]="'/assurancequalite/nonconformite/' + nonConformite.idNonConformite">{{nonConformite.numero}}</a>
                            <p-tag *ngIf="nonConformite.nouveauxMessages" severity="info" value="Nouveau message" [routerLink]="'/assurancequalite/nonconformite/' + nonConformite.idNonConformite" class="cursor-pointer"></p-tag>
                        </td>
                        <td *ngIf="EstColonneSelectionnee('titre')">{{nonConformite.titre}}</td>
                        <td *ngIf="EstColonneSelectionnee('codeProjet')">{{nonConformite.codeProjet.code}}</td>
                        <td *ngIf="EstColonneSelectionnee('statut')">
                            <div class="flex-column sm:flex align-items-center gap-1">
                                <span [class]="'statut ' + nonConformite.statut.nom.toLowerCase()">
                                    {{nonConformite.statut.nom}}
                                </span>
                                <p-tag *ngIf="nonConformite.actionCorrectiveId" severity="primary" value="Action corrective" [routerLink]="'/assurancequalite/actioncorrective/' + nonConformite.actionCorrectiveId" class="cursor-pointer"></p-tag>
                            </div>
                        </td>
                        <td *ngIf="EstColonneSelectionnee('dateEmission')">{{nonConformite.dateEmission | date: 'dd/MM/yyyy'}}</td>
                        <td *ngIf="EstColonneSelectionnee('dateDetection')">{{nonConformite.dateDetection | date: 'dd/MM/yyyy'}}</td>
                        <td *ngIf="EstColonneSelectionnee('type')">{{nonConformite.type == 'Q' ? 'Qualité' : nonConformite.type == 'S' ? 'SST' : 'Environnement'}}</td>
                        <td *ngIf="EstColonneSelectionnee('objet')">{{nonConformite.objet}}</td>
                        <td *ngIf="EstColonneSelectionnee('employe')"><app-employe-avec-emplacement [employe]="nonConformite.employe"></app-employe-avec-emplacement></td>
                        <td *ngIf="EstColonneSelectionnee('approbation')">{{nonConformite.approbation == null ? 'Non traité' : nonConformite.approbation}}</td>
                        <td *ngIf="EstColonneSelectionnee('monetaire')">
                            <div class="flex flex-column gap-2">
                                <div *ngIf="nonConformite.monetaire" class="p-2 surface-100 border-round">
                                    <span class="font-semibold">Sous-traitant:</span>
                                    <span class="ml-2">{{nonConformite.monetaire| currency:'CAD'}}</span>
                                    <span class="text-sm text-500 ml-2">({{nonConformite.modeEstimation ? 'estimé' : 'réel'}})</span>
                                </div>
                                <div *ngIf="nonConformite.monetaireHamel" class="p-2 surface-200 border-round">
                                    <span class="font-semibold">HAMEL:</span>
                                    <span class="ml-2">{{nonConformite.monetaireHamel| currency:'CAD'}}</span>
                                    <span class="text-sm text-500 ml-2">({{nonConformite.modeEstimationHamel ? 'estimé' : 'réel'}})</span>
                                </div>
                            </div>
                        </td>
                        <td *ngIf="EstColonneSelectionnee('nbMessages')">{{nonConformite.nbMessages}}</td>
                        <td *ngIf="EstColonneSelectionnee('dateDernierMessage')">{{nonConformite.dateDernierMessage | date: 'dd/MM/yyyy'}}</td>
                        <td class="celluleTableau" alignFrozen="right" pFrozenColumn>
                            <div class="flex justify-content-end">
                                <button *ngIf="nonConformite.actionCorrectiveId" pButton pRipple label="AC" class="p-button-primary mr-2 boutonGrille" [tooltip]="'Voir l\'action corrective'"
                                (click)="openActionCorrective(nonConformite)"></button>
                                <button pButton pRipple icon="pi pi-eye" class="p-button-success mr-2 boutonGrille" [pTooltip]="'Voir la non-conformité'"
                                (click)="openNonConformite(nonConformite.idNonConformite)"></button>
                            </div>
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </p-card>
    </div>
</div>